import React, { useState } from "react";

import { Header } from "../../components";
import { HealthAccordion } from "../../components";
import { METRIC_TYPES } from "../../constants/global";
import DashboardItem from "./component/DashboardItem";
import { BodyContainer } from "../../components/BaseComponents";

const Dashboard = (props) => {
  const [percentUptime, setPercentUptime] = useState(undefined);
  const [averageLatency, setAverageLatency] = useState(undefined);

  const updateRequestLatency = (value) => setAverageLatency(value);

  const updateCheckMetric = (value) => setPercentUptime(value);

  return (
    <>
      <Header headerTitle="Dashboard" onDrawerToggle={props.onDrawerToggle} />
      <BodyContainer>
        <HealthAccordion title="Network Latency" type={METRIC_TYPES.REQUEST_LATENCY} averageLatency={averageLatency}>
          <DashboardItem type={METRIC_TYPES.REQUEST_LATENCY} updateRequestLatency={updateRequestLatency} />
        </HealthAccordion>
        <HealthAccordion title="Uptime Metric" type={METRIC_TYPES.CHECK_PASSED} percentUptime={percentUptime}>
          <DashboardItem type={METRIC_TYPES.CHECK_PASSED} updateCheckMetric={updateCheckMetric} />
        </HealthAccordion>
      </BodyContainer>
    </>
  );
};

export default Dashboard;
